<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Create Indicator
    </h1>
    <div id="card">
      <div class="card-section">
        <popups></popups>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">MEA</p>
            <select class="section-property" id="indicator-mea"
                    name="mea" v-model="selectedMea">
              <option selected>Select MEA ...</option>
              <option v-for="(mea,index) in mea_options" :key="index"
                :value="mea.id">
                {{ mea.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Name</p>
            <input id="indicator-name" type="text" name="name" />
          </div>

          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Category</p>
            <select class="section-property" id="indicator-category"
              name="category">
              <option v-for="(category, index) in category_options" :key="index"
                  :value="category.id">{{ category.name }}
              </option>
            </select>
          </div>

          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Priority</p>
            <select class="section-property" id="indicator-priority"
                name="priority">
              <option v-for="(priority,index) in priority_options" :key="index"
                  :value="priority.value">{{ priority.label }}
              </option>
            </select>
          </div>
        </div>

        <div class="row section-body">
          <div class="col-sm-2 section-property-block">
            <p class="section-property-title">Publish</p>
            <select id="indicator-publish" name="publish" class="section-property">
                <option v-for="(option,index) in published_options" :key="index"
                    :value="option.value" >{{ option.label }}
                </option>
            </select>
          </div>
          
          <div class="col-sm-2 section-property-block">
            <p class="section-property-title">Display Unit</p>
            <input id="indicator-unit" name="unit" type="text"/>
          </div>
        </div>

        <div class="row section-body">
          <div class="col-sm-6 section-property-block">
            <p class="section-property-title">Data Sources</p>
            <multi-select v-model="data_sources" label-key="name" value-key="name"
              :options="datasource_options" filterable block/>
          </div>
        </div>
      </div>

      <div class="row section-body">
        <div class="col-sm-6 section-property-block">
          <p class="secton-property-title">Description</p>
          <textarea name="description" id="indicator-description"
                    type="text"></textarea>
        </div>
      </div>

      <div class="card-section sub-section">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitIndicator()">Create</btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import { bus } from '../../main';
import constants from '../../constants';
import store from '../../store.js';
import DetailCard from '../DetailCard';
import { MultiSelect } from 'uiv'
import Popups from '../Popups';

export default {
  data () {
      return {
        errors: [],
        data_sources: [],
        selectedMea: '',
        message: {type: 'warning', title:'Indicator'},
        published_options: [{ 'label': 'No', 'value': false },
                            { 'label': 'Yes', 'value': true }]
      };
  },
  computed: {
    ...mapGetters([ 'hasErrors', 'getErrors' ]),
    ...mapState({
      // Extract things like this out into a Mixin
      datasource_options: function(){
        return store.state.dataSources;
      },

      priority_options: function(state){
        if (!state.indicatorDetails.hasOwnProperty('priorities'))
          return []
        return state.indicatorDetails['priorities']
      },
      categories: function(state){
        return state.categories
      },
      mea_options: function(state){
        return state.meas
      }
    }),
    category_options: function(){
      let _this = this;
      if (_this.selectedMea){
        return _this.categories.filter(function(category){ return category.mea === _this.selectedMea});
      }
      return [{id:'', name:'No applicable categories present'}];
    }
  },
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
    
    reset: function() {
      this.errors = [];
      bus.$emit('reset', {});
    },

    redirect: function(action) {
      if (action == 'success') this.$router.push('/indicators');
    },

    trimValue: function(value) {
      return (value != undefined || value != null)? value.trim() : value;
    },

    showPopup: function(value, type) {
      bus.$emit(type, { data: value });
      this.redirect(value.type);
    },

    resetTemplate: function() {
      this.clearFields(document.getElementById('card'));
    },

    clearFields: function(element) {
      for (var i = 0; i < element.childNodes.length; i++) {
         var e = element.childNodes[i];
         if (e.tagName) switch (e.tagName.toLowerCase()) {
            case 'input':
               switch (e.type) {
                  case "radio":
                  case "checkbox": e.checked = false; break;
                  case "button":
                  case "submit":
                  case "image": break;
                  default: e.value = ''; break;
               }
               break;
            case 'select': e.selectedIndex = 0; break;
            case 'textarea': e.value = ''; break
            default: this.clearFields(e);
         }
      }
    },

    createIndicator: async function(data) {
      let failed = constants.message.create.failed;
      let success = constants.message.create.success;
      let response  = await store.dispatch('createIndicator', { indicator: data });

      if(response != null){
        this.message.type = 'success';
        this.message.content = success;
      } else this.message.content = failed;
      this.showPopup(this.message, 'notification');
    },

    submitIndicator: function() {
      this.reset();

      let datasource_list = [];
      let _datasource_options = this.datasource_options;

      let name = $("#indicator-name").val();
      let description = $("#indicator-description").val();
      let priority = $("#indicator-priority option:selected").val();
      let category = $("#indicator-category option:selected").val();
      let is_published = $('#indicator-publish option:selected').val();
      let unit = $("#indicator-unit").val();

      if (name.length == 0) {
        this.errors.push('Name is required!');
      }

      // get important field values from data source options
      this.data_sources.forEach(function(selected) {
        _datasource_options.forEach(datasource => {
          if(datasource !== undefined) {
            if(datasource.name.toLowerCase().trim() == selected.toLowerCase().trim())
              datasource_list.push(datasource.id)
          }
        });
      });

      if (this.errors.length > 0) this.showPopup({'content': this.errors }, 'alert');
      else {
        let data = {'name': this.trimValue(name), 'priority': priority,
                    'is_published': is_published, 'category': category,
                    'data_sources': datasource_list, 'description': description, 
                    'unit': unit};

        // submitting new indicator to api
        this.createIndicator(data);
      }
    },
  },
  components: {
    MultiSelect,
    Popups
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchMeas');
    store.dispatch('fetchCategories');
    store.dispatch('fetchIndicatorPriorities');
    store.dispatch('fetchDataSources');
    next();
  },

  beforeDestroy () {
    store.dispatch('resetErrors');
  },
};
</script>

<style scoped lang="scss">
@import "../../css/constants";
/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}

h1.detail-title{
  background-color: #04bafc;
  padding: 20px;
  margin-left: -40px;
  margin-right: -40px;
  color: white;
  height: auto;
  margin-bottom: 25px;
  
  i { 
    cursor: pointer;
    display: none; 
    font-size: 1.1em; 
    margin-top: -4px; 
    vertical-align: middle; 
    text-shadow:  0px 1px 1px rgba(0, 0, 0, 0.1);
    
    &:hover {
      color: #f1f1f1;
    }
  }
}

.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body { display: flex; flex-wrap: wrap; }
.sub-section { margin-top: 30px; }
.section-title {
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}
.plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}
.plus > img{
  margin: auto;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }
  
  @media only screen and (min-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
    }
  }

  @media only screen and (min-width: 468px) and (max-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px;  }
    }
  }

  @media only screen and (max-width: 467px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px; }
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/indicators/CreateIndicator.vue